import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import ImageUpload from '@/components/ImageUpload/index.vue'
import PageBack from '@/components/PageBack/index.vue'
import './styles/index.scss'
import './permission'

Vue.use(ElementUI, { size: 'small' })
Vue.component('ImageUpload', ImageUpload)
Vue.component('PageBack', PageBack)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
